export default "__VITE_ASSET__BgyoZfXd__"